import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        items: [],
        itemsFetched: false
    },
    getters: {
        getItems: state => state.items
    },
    mutations: {
        SET_FETCHED(state, reset = false) {
            state.itemsFetched = !reset;
        },
        SET_ITEMS(state, items) {
            state.items = items;
        },
        UNSHIFT_ITEMS: (state, payload) => {
            const newItem = payload.data;
            state.items.unshift(newItem);
        },
        EDIT_ITEM(state, payload) {
            const itemIndex = state.items.findIndex(x => x.id === payload.id);
            Vue.set(state.items, itemIndex, {
                ...state.items[itemIndex],
                ...payload,
            });
        },
        REMOVE_ITEM(state, payload) {
              const itemIndex = state.items.findIndex(
                  x => x.id === payload.id
              );
              if (itemIndex > -1) {
                Vue.delete(state.items, itemIndex);
              }
        },
    },
    actions: {
        fetch(context, payload = {}) {
            payload.url = '/api/blacklist';
            const disableStoreUpdate = payload.disableStoreUpdate || false;
            const force = payload.force || null;
            const forcedLanguage = payload.forcedLanguage || null;
            if(!force && !forcedLanguage && context.state.itemsFetched) {
                return {data: context.getters.getItems};
            }
            return context.dispatch('post', payload, { root: true }).then((response) => {
                if (!disableStoreUpdate && !response.data.error) {
                    context.commit('SET_FETCHED');
                    context.commit('SET_ITEMS', response.data);
                }
                return response;
            });
        },
        fetchByCountryId: (context, payload = {}) => {
            payload.url = '/api/admin/blacklist/fetchByCountryId/' + payload.id;
            return context.dispatch('get', payload, { root: true }).then((response) => {
                return response;
            });
        },
        fetchById: (context, payload = {}) => {
            payload.url = '/api/admin/blacklist/fetchById/' + payload.id;
            return context.dispatch('get', payload, { root: true }).then((response) => {
                return response;
            });
        },
        add: (context, payload = {}) => {
            payload.url = '/api/admin/blacklist/add';
            return context.dispatch('post', payload, { root: true }).then((response) => {
                if (!response.data.error) {
                    context.commit('UNSHIFT_ITEMS', {
                        data: response.data,
                    });
                }
                return response;
            });
        },
        edit: (context, payload = {}) => {
            payload.url = '/api/admin/blacklist/edit';
            return context.dispatch('post', payload, { root: true }).then((response) => {
                if (!response.data.error) {
                    context.commit('EDIT_ITEM', response.data);
                }
                return response;
            });
        },
        delete: (context, payload = {}) => {
            payload.url = '/api/admin/blacklist/delete';
            return context.dispatch('post', payload, { root: true }).then((response) => {
                if (!response.data.error) {
                    context.commit('REMOVE_ITEM', payload);
                }
                return response;
            });
        },
        clearItems({ commit }) {
            commit('SET_FETCHED', true);
            commit('SET_ITEMS', []);
        },
    },
};
